{
  "schemaVersion": "1.0",
  "status": "DRAFT_DIRECTIONAL",
  "note": "Directional marketing content. Prices are management targets; public-pricing.json must be generated from Pricing Master at publish.",
  "id": "shop",
  "order": 5,
  "accent": "teal",
  "eyebrow": "MAINTENANCE EXECUTION",
  "title": "Shop",
  "valueStatement": "Plan, execute, inspect, close, and deliver maintenance work, with continuity across every shift and handoff.",
  "outcome": "Complete the work with continuity.",
  "workflow": [
    "Induct",
    "Plan",
    "Execute",
    "Inspect",
    "Close Out",
    "Deliver"
  ],
  "intelligenceInContext": {
    "name": "shopIQ · shiftIQ",
    "headline": "AI that understands the work in progress.",
    "helpsWith": [
      "Summarize open work for incoming shifts",
      "Surface similar past findings",
      "Flag missing evidence before closeout",
      "Find parts and references for the task"
    ],
    "drawsOn": [
      "Intelligence",
      "Vault",
      "Human Intelligence"
    ],
    "humanAuthority": "Signoff, inspection, and return to service stay with authorized people.",
    "aiUsage": "AI assistance uses credits; signoff and records never do."
  },
  "evidenceProduced": [
    "Signed job cards",
    "Inspection records",
    "Trace documents",
    "Findings & photos",
    "Delivery packages"
  ],
  "regulatory": {
    "anchors": [
      "part-145",
      "p43-9",
      "p43-11",
      "part-65",
      "ac-120-78b"
    ],
    "included": [
      "Credential-aware signoff",
      "Inspection routing",
      "Immutable signed records",
      "Audit trail"
    ],
    "readinessServices": [
      "ext-esign-readiness",
      "ext-workflow-extensions"
    ]
  },
  "externalParticipants": "Aircraft owners and operator representatives get restricted access to their own events at no charge.",
  "pricingId": "shop",
  "showExtensions": true
}